<div class="bell-container"
  (click)="goToNotificationsPage()">
  <ion-icon src="assets/icon/icon-notifications.svg" />
  @if (unreadNotificationCount$ | async; as unreadNotificationCount) {
    @if (unreadNotificationCount > 0) {
      <div class="badge-container">
        <ion-label>{{ unreadNotificationCount }}</ion-label>
      </div>
    }
  }
</div>
